
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useLocation } from "react-router-dom";
import qpayLogo from "../img/qpayLogo.png"
import { pallete } from './Pallete';
import BurgerMenu from './BurgerMenu';

const Navigation = () =>{
  const { pathname } = useLocation();
    return(
        <>
        <StyledNav> 
              <Link to="/" id="logo"><img src={qpayLogo} alt="Logo"/></Link>          
            <ul>
                <li>
                  <Link style={{ backgroundColor: pallete.LogoBlue}} to="/" >Home</Link>
                </li>
                <li>
                  <Link style={{ backgroundColor: pallete.LogoPink}}to="/about" >About Us</Link>
                </li>
                <li>
                  <Link style={{ backgroundColor: pallete.LogoOrange}} to="/why" >Why Choose QPay</Link>                  
                </li>
                <li>
                  <Link style={{ backgroundColor: pallete.LogoBlue}} to="/how" >How It Works</Link>                  
                </li>
                <li>
                  <Link style={{ backgroundColor: pallete.LogoPink}} to="/contact" >Contact</Link>                  
                </li>
            </ul>
        </StyledNav>
        <BurgerMenu />
        </>
    )
}

const StyledNav = styled.nav`

  width:100%;
  min-height: 10vh;
  display: flex;
  margin: auto;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 10rem;
  position: relative !important;
  top: 0;
  z-index: 100;
  background-color: ${pallete.BackGround};
    img{
      width: 150px;
      height:auto;  
    } 
    a{
      font-family: 'Lato', sans-serif;
      text-decoration: none;
      -webkit-background-clip: text;
      -moz-background-clip: text;
      -webkit-text-fill-color: transparent; 
      -moz-text-fill-color: transparent;
    }
    ul{
        display: flex;
        list-style: none;
    }
    li{
        padding-left: 7rem;
        position: relative;
    }
    @media (max-width: 1300px) {
      padding: 1rem 1rem;
      #logo {
        display: inline-block;
        margin: 1rem;
      }
      ul {
        padding: 2rem;
        justify-content: space-around;
        width: 100%;
        li {
          padding: 0;
        }
      }
    }
  @media (max-width: 460px) {
    ul {
        justify-content: space-between;
    }
  }
  @media (max-width: 780px) {
    display:none;
  }
`;



export default Navigation;


